/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';
import { cleanExternalLinks } from '../../lib/utils';

import Blocks from '../blocks/Blocks';

import styles from '../../../styles/partials/page-heading.module.scss';

const propTypes = {
    title: PropTypes.string,
    button: PropTypes.node,
    blocks: AppPropTypes.blocks,
    children: PropTypes.node,
    className: PropTypes.string,
    topClassName: PropTypes.string,
    isDark: PropTypes.bool,
};

const defaultProps = {
    title: null,
    button: null,
    blocks: null,
    children: null,
    className: null,
    topClassName: null,
    isDark: false,
};

const PageHeading = ({ title, button, blocks, children, className, topClassName, isDark }) => (
    <div
        className={classNames(styles.container, {
            [className]: className !== null,
            [styles.isDark]: isDark,
        })}
    >
        {button !== null || title !== null ? (
            <div
                className={classNames(styles.top, {
                    [topClassName]: topClassName !== null,
                })}
            >
                {title !== null ? (
                    <h2
                        className={styles.title}
                        dangerouslySetInnerHTML={{ __html: cleanExternalLinks(title) }}
                    />
                ) : null}
                {button !== null ? button : null}
            </div>
        ) : null}
        {blocks !== null && blocks.length > 0 && (
            <Blocks className={styles.blocks} blocks={blocks} />
        )}
        {children}
    </div>
);

PageHeading.propTypes = propTypes;
PageHeading.defaultProps = defaultProps;

export default PageHeading;
